import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { IconButton, Edit } from '@tds/core-interactive-icon';
import Overlay from './overlay';

const EditButton = ({ id, name, fetchData }) => {
  const [inEditMode, setInEditMode] = useState(false);

  return (
    <>
      <IconButton
        icon={Edit}
        onClick={() => {
          setInEditMode(true);
        }}
        a11yText="Edit"
      />
      {inEditMode && (
        <Overlay
          setInEditMode={setInEditMode}
          id={id}
          name={name}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

EditButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default EditButton;
